import {Component, ViewContainerRef, OnInit, ViewChild} from '@angular/core';
import { Router } from "@angular/router";
import { NgForm, FormGroup } from "@angular/forms";
import { DataService} from "../services/data.service";
import { ToastsManager} from 'ng2-toastr/ng2-toastr';
import { EditDataService, Info} from "../services/edit-data.service";
import { Http, Response } from '@angular/http';
import data from "devextreme/bundles/dx.all";

/*import {InfoService, Info} from "../services/loginInfo";
 import {setTimeout} from "timers";*/


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [ToastsManager],
})
export class LoginComponent implements OnInit {

  username: string;

  public data: any = [];
  form: FormGroup;
  progress: boolean;
  ticks: number;
  footer: any;


  constructor(public router: Router,
              public dataService: DataService,
              public editDataService: EditDataService,
              public toastr: ToastsManager,
              public vRef: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vRef);

    localStorage.removeItem('data');
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('idd');

    this.progress = false;

  }

  @ViewChild('f1') firstForm: NgForm;


  onSubmitFirst(form: NgForm){
    console.log(form);
    this.verificate(form.value.IDcontract, form.value.CScontract);
  };
  resolved(e) {
    /*console.log(e);*/
    if (e === null) {
      this.firstForm.controls['captcha'].reset();
    }
  };


  onSubmitLk(form: NgForm){
    console.log(form);
    this.dataService.postLcLogin(form.value)
      .subscribe(
        (data : Response) => {
          this.dataService.login();
          this.dataService.setPersonalCabinetData(data.json());

          console.log(data.json());

          this.router.navigate(['/cabinet']);
        },
        error => {
          error = JSON.parse(error._body);
          this.toastr.error(error.message, error.status_code,{dismiss: 'click'});
        }
      );
  };
  onRegister (){
    this.router.navigate(['/registration']);
  };


  ngOnInit() {
    this.editDataService.getData().subscribe(data => this.data = data);

 /*   let session = localStorage.getItem("clientId");
    if (session) {
      this.dataService.getPersonalCabinetData().subscribe(
        (data: Response) => {
          this.dataService.login( );
        },
        error => {
          localStorage.removeItem('clientId');
        }
      );
    }*/
  };


  verificate(IDcontract: number, CScontract: number) {
    this.dataService.getDataByIddCsd(IDcontract, CScontract)
      .subscribe(
        data => {
          this.progress = false;
          this.dataService.setData(data);
          this.router.navigate(['/order']);
        },
        error => {
          this.progress = false;
          error = JSON.parse(error._body);
          if (error.error === 'maintenance') {
            return this.router.navigate(['/maintenance']);
          }
          this.toastr.error(error.message, error.status_code,{dismiss: 'click'});
        }
    );
  };

  /**
   * Review
   * Todo:
   * Это обработчик события?
   */
  progressClick() {
    this.progress = true;
    this.ticks = 90;
    /**
     * Review
     * Todo:
     * Зачем реализовывать самому setTimeout?
     */
    let progresTimer = setInterval(() => {
      if (this.ticks === 0) {
        //noinspection TypeScriptUnresolvedFunction
        clearInterval(progresTimer);
        this.progress = false;
      }
      else {
        this.ticks--;
      }
    }, 1000);
  }
}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/login/login.component.ts